'use client';

import { Button, Stack, Text } from 'components/ui';
import router from 'next/router';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { PATHS } from 'settings/config';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from 'styles/global-theme';

const UpgradeContainer = styled.div`
  padding: 40px;
  background-color: #f8f8f8;
  border-radius: 16px;
  background-image: url('/images/blur-bg.png');
  background-repeat: no-repeat;
  background-position: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media screen and (max-width: ${breakpoints.small}) {
    padding: ${globalTheme.space[2]};
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 12px 0;

  &:before {
    content: '✓';
    color: ${globalTheme.colors.pink};
    font-weight: bold;
    margin-right: 12px;
    font-size: 18px;
  }
`;

const FreeTrialButton = styled(Button)`
  margin-top: ${globalTheme.space[0]};
  color: white;
  padding: 12px 24px;
  font-weight: 600;
  width: max-content;

  @media screen and (max-width: ${breakpoints.small}) {
    display: flex;
    margin: ${globalTheme.space[0]} auto;
  }
`;

const Title = styled(Text)`
  margin: 20px;
  font-weight: bold;
`;

const SubTitle = styled(Text)`
  color: #666;
`;

const Divider = styled.div`
  background: #aaaaaa;
  height: 1px;
  width: 100%;
`;

const InfoText = styled(Text)`
  color: #5d5d5d;
  margin-top: ${globalTheme.space[1]};
`;

const HighlightText = styled(Text)`
  font-weight: bold;
  color: ${globalTheme.colors.pink};
  margin-bottom: ${globalTheme.space[1]};
`;

function UpgradeAgora() {
  const INFO = [
    'No cost to join, simple setup, and built for ease of use',
    'Access to more buyers, sellers and agents',
    'A transparent livestock marketplace',
    'Deal directly with buyers, sellers and agents',
  ];

  return (
    <>
      <Title fontSize={4}>Seller Contact Information</Title>

      <UpgradeContainer>
        <Stack space={0}>
          <HighlightText fontSize={5}>
            Interested in finding out more?
          </HighlightText>

          <SubTitle fontSize={3}>
            Registration costs nothing and only takes a few moments.
          </SubTitle>

          <Divider />

          <div>
            {INFO.map((feature, index) => (
              <FeatureItem key={index}>
                <Text fontSize={3}>{feature}</Text>
              </FeatureItem>
            ))}
          </div>

          <InfoText fontSize={3}>
            Use the "Ask a question" button above to send the seller your
            contact details and a message (no login required)
          </InfoText>
        </Stack>

        <FreeTrialButton
          size='medium'
          onClick={() => router.push(PATHS.auth.signUp)}
        >
          Create Account - It's Free!
        </FreeTrialButton>
      </UpgradeContainer>
    </>
  );
}

export default UpgradeAgora;
